module.exports = __webpack_public_path__ + "img/extended.c58a80da.png";